import {
  AlertColor,
  Box,
  Button,
  IconButton,
  InputAdornment,
  styled,
  TextField,
  Theme,
  useMediaQuery,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { globalTheme } from "../../../common/theme";
import createStyles from "@mui/styles/createStyles";
import axios from "axios";
import React from "react";
import { Package, ProductListItem, ProductPackageListItem } from "./ProductAccessories";
import { SnackBarMessage, SnackBarMessageProps } from "../../component/SnackBarMessage";
import Title from "../../component/Title";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { GridCellParams, GridColumns, GridRenderCellParams, GridToolbarContainer, GridValueSetterParams } from "@mui/x-data-grid";
import { Add, Delete, Save, Search } from "@mui/icons-material";
import { renewToken } from "../../../services/AuthService";
import { useConstructor } from "../../../common/UseConstructor";
import { ProductList, ProductListHandle } from "./ProductList";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
  })
);

const StyledBox = styled(Box)(({ theme }) => ({
  height: "100%",
  width: "100%",
  "& .super-app-theme--cell": {
    backgroundColor: "rgba(41, 67, 63, 0.90)"
  },
}));

export function ProductPackageManagement() {
    const style = { ...useStyles(), ...globalTheme() };

    const tinyScreen = useMediaQuery('(max-width:1366px)');
    const smallScreen = useMediaQuery('(max-width:1920px)');
    const normalScreen = useMediaQuery('(max-width:2560px)');

    const productListModalRef = React.useRef<ProductListHandle>(null);

    const [loading, setLoading] = React.useState<boolean>(false);

    const hasChanges = React.useRef<boolean>(false);

    const [packages, setPackages] = React.useState<Package[]>([]);
    const [gridData, setGridData] = React.useState<ProductPackageListItem[]>([]);
    const [selectedPackageId, setSelectedPackageId] = React.useState<number>(-1);
    const [selectedProductId, setSelectedProductId] = React.useState<number>(0);

    //Grid columns
    const packagecolumns: GridColumns = [
      { field: 'id', headerName: '', disableColumnMenu: true, sortable: false, 
        width: 40, minWidth: 40,
        renderCell: (cellValues) => {
          return (
            <IconButton
              sx={{ minHeight: 0, minWidth: 0, padding: 0 }}
              onClick={(event) => {
                DeletePackage(event, cellValues);
              }}
            >
              <Delete />
            </IconButton>
          );
        }
      },
      { field: 'description', headerName: 'Product Package', flex: 1, type: 'string', editable: true,
          valueSetter: (param: GridValueSetterParams) => onPackageChanged(param),
          cellClassName: (params: GridCellParams<number>) => {
            if (params.value == null) {
              return "";
            }

            if (params.row.id == 0)
              return "super-app-theme--cell";
            else
              return "";
        }
      }
    ];

    const columns: GridColumns = [
      { field: 'id', headerName: '', disableColumnMenu: true, sortable: false, 
        width: 40, minWidth: 40,
        renderCell: (cellValues) => {
          return (
            <IconButton
              sx={{ minHeight: 0, minWidth: 0, padding: 0 }}
              onClick={(event) => {
                DeletePackageItem(event, cellValues);
              }}
            >
              <Delete />
            </IconButton>
          );
        }
      },
      { field: 'displayOrder', headerName: '並べ替え', flex: 0.5, type: 'number', editable: true,
        valueSetter: (param: GridValueSetterParams) => onDisplayOrderChanged(param),
      },
      { field: 'model', headerName: '型式', flex: 4, type: 'string' },
      { field: 'nameJpn', headerName: '製品名', flex: 5, type: 'string' },
      { field: 'productCode', headerName: '商品CD', flex: 2, type: 'string' },
    ];
    
    const [searchText, setSearchText] = React.useState("");

    
    function onPackageChanged(param: GridValueSetterParams) {
      let row: Package = param.row;

      if (row.description != param.value)
      {
        row.description = param.value.slice(0, 50); 

        hasChanges.current = true;
  
        EditPackage(row);
      }

      return { ...param.row, row };
    }
    
    function onDisplayOrderChanged(param: GridValueSetterParams) {
      let row: ProductPackageListItem = param.row;

      if (row.displayOrder != param.value)
      {
        row.displayOrder = param.value; 
        hasChanges.current = true;
      }

      let tempGridData = [...gridData];
      let gridDataIndex = tempGridData.findIndex(x => x.productID == row.productID);
      let item = tempGridData[gridDataIndex];
      item.displayOrder = row.displayOrder;
      tempGridData[gridDataIndex] = item;
      setGridData(tempGridData);

      let tempPackages = [...packages];
      let index = tempPackages.findIndex(x => x.packageID == row.packageID);
      let productPackage = tempPackages[index];
      productPackage.packageItems = tempGridData;
      EditPackage(productPackage);

      return { ...param.row, row };
    }

    //Dialogs and snacks
    const [snackSettings, setSnackSettings] =
      React.useState<SnackBarMessageProps>({
        open: false,
        message: "",
        subMessage: "",
        severity: undefined,
        onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => {}})
      });

    function showSnackBar(message: string, subMessage: string, colour?: AlertColor) {
      setSnackSettings({
        open: true,
        message: message,
        subMessage: subMessage,
        severity: colour,
        onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => {}})
      });
    }

    function PackageToolbar() {
      const [inputText, setInputText] = React.useState(searchText);
      return (
        <GridToolbarContainer style={{ display: 'flex' }}>
          <TextField className={style.ModalContentFieldHalfWidth}
            style={{ minWidth: '100px', width: '100%' }}
            label="Package name"
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            onKeyDown={(e) => KeyPressed(e.key, inputText)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => {
                      setSearchText(inputText);
                      SearchPackage(inputText);
                    }}><Search />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            size="small"            
          />
          <div style={{ width: "10px", minWidth: "10px" }}></div>
          <Button style={{ width: tinyScreen ? "60px" : (smallScreen ? "75px" : "90px"), minWidth: tinyScreen ? "60px" : (smallScreen ? "75px" : "90px") }}
            disabled={ inputText.length == 0 }
            variant="contained" size="small" color="secondary" startIcon={<Add />} onClick={() => NewPackage(inputText)}>Add</Button>
          <div style={{ width: "10px", minWidth: "10px" }}></div>
        </GridToolbarContainer>
      );
    }

    function PackageItemToolbar() {
      return (
        <GridToolbarContainer style={{ display: 'flex' }}>
          <Button style={{ width: tinyScreen ? "60px" : (smallScreen ? "75px" : "90px"), minWidth: tinyScreen ? "60px" : (smallScreen ? "75px" : "90px"), margin: 10 }}
            variant="contained" size="small" color="secondary" startIcon={<Add />} onClick={() => AddProduct()}>Add</Button>
          <Button style={{ width: tinyScreen ? "60px" : (smallScreen ? "75px" : "90px"), minWidth: tinyScreen ? "60px" : (smallScreen ? "75px" : "90px") }}
            disabled = { hasChanges.current == false }
            variant="contained" size="small" color="secondary" startIcon={<Save />} onClick={() => EditPackage(packages.find(x => x.packageID == selectedPackageId))}>Save</Button>
        </GridToolbarContainer>
      );
    }

    function KeyPressed(key: string, inputText: string) {
      if(key === 'Enter'){
        setSearchText(inputText);
        SearchPackage(inputText);
      }      
    }

    function NewPackage(packageDescription: string) {
      if (packages.findIndex(x => x.description == packageDescription) > -1)
      {
        showSnackBar("Package name already exists", "", "error");
        return;
      }
      if (packageDescription=="")
      {
        showSnackBar("Please enter a package name for the package.", "", "error");
        return;
      }

      let newProductPackage: Package = {
        id: 0,
        packageID: 0,
        description: packageDescription,
        packageItems: []
      }

      axios.post<Package>('Api/V1/Package', newProductPackage).then(
        (result) => {
          let temp = [...packages];
          let productPackage = result.data; 
          if (result.data.packageItems==null)
          {
            productPackage.packageItems = [];
          }
          productPackage.id = result.data.packageID;
          temp.unshift(productPackage);
          setPackages(temp);
          hasChanges.current = false;
          showSnackBar("Product package created successfully.", "", "success");
        },
        (error) => {
          showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
        }
      );
    }

    function EditPackage(productPackage: Package | undefined) {
      if (!productPackage)
        return;

      if (productPackage.description=="")
      {
        showSnackBar("Please enter a package name for the package.", "", "error");
        return;
      }

      if (productPackage.packageID==0)
      {

      }
      else
      {
        axios.put<Package>('Api/V1/Package', productPackage).then(
          (result) => {
            let temp = [...packages];
            let index = temp.findIndex(x => x.packageID === productPackage.packageID);
            temp[index] = productPackage;
            setPackages(temp);
            hasChanges.current = false;
            showSnackBar("Product package updated successfully.", "", "success");
          },
          (error) => {
            showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
          }
        );
      }
    }
  
    function DeletePackage(e: React.MouseEvent<HTMLButtonElement, MouseEvent>, values: GridRenderCellParams) {
      axios.delete<boolean>('Api/V1/Package/' + values.row.packageID).then(
        (result) => {
          if (result.data)
          {
            SearchPackage("");
            setSelectedPackageId(-1);
            setGridData([]);
            showSnackBar("Product package deleted successfully.", "", "success");
          }
        },
        (error) => {
          showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
        }
      );

    }

    function AddProduct() {
      productListModalRef.current?.Initialise();
    }

    function PopulateSelectedProducts(hasSelection: boolean, productItems: React.MutableRefObject<ProductListItem[]>) {
      if (!hasSelection)
        return;

      hasChanges.current = true;  
      let newPackageItems: ProductPackageListItem[] = [];
      let index = packages.findIndex(x => x.packageID == selectedPackageId);
      if (index > -1) {
        let displayOrders: number[] | undefined = gridData.map(i => i.displayOrder);

        let maxDisplayOrder: number = 1;
        if (displayOrders && displayOrders.length > 0) {
          maxDisplayOrder = Math.max(...displayOrders) + 1;
        }

        productItems.current.forEach((item) => {
            let productDescription: string = item.nameJpn ?? (item.nameChi ?? (item.nameEng ?? ""));

            const packageItem: ProductPackageListItem = {
              id: item.productID,
              packageID: selectedPackageId,
              productID: item.productID,
              model: item.model,
              nameJpn: productDescription,
              productCode: item.productCode,
              displayOrder: maxDisplayOrder
            };
            if (gridData.findIndex(x => x.productID == item.productID) == -1)
            {
              newPackageItems.push(packageItem);
              maxDisplayOrder++;
            }
          }
        )

        let tempData = [...gridData, ...newPackageItems];
        setGridData(tempData);

        let tempPackages = [...packages];
        tempPackages[index].packageItems = tempData;
        setPackages(tempPackages);
      }

    }

    function SearchPackage(inputText: string) {
      setLoading(true);

      const params = { searchString: inputText };
      axios.get<Package[]>('Api/V1/Package/Search', {
        params,
        headers: {
          'Content-Encoding': 'gzip'
        }
      })
        .then((result) => {
          result.data.forEach(i => {
            i.id = i.packageID;
          });
          setPackages(result.data)
          setLoading(false);
        },
          (error) => {
            setPackages([]);
            setLoading(false);
            console.log(error);
            showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
          }
        )
        .catch((error) => {
          setLoading(false);
          console.log(error);
          showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
        });
    }
  
    function DeletePackageItem(e: React.MouseEvent<HTMLButtonElement, MouseEvent>, values: GridRenderCellParams) {
      axios.delete<boolean>('Api/V1/Package/' + values.row.packageID + "/" + values.row.productID).then(
        (result) => {
          if (result.data)
          {
            ReloadPackageItems(values.row.packageID);

            showSnackBar("Package item deleted successfully.", "", "success");
          }
        },
        (error) => {
          showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
        }
      );

    }

    function ReloadPackageItems(packageId: number) {
      setLoading(true);

      axios.get<ProductPackageListItem[]>('Api/V1/Package/' + packageId.toString(), {
          headers: {
              'Content-Encoding': 'gzip'
          }
      })
          .then((result) => {
              result.data.forEach(i => {
                  i.id = i.productID;
              });
              setGridData(result.data)

              let temp = [...packages];
              let index = temp.findIndex(x => x.packageID === packageId);
              let productPackage = temp[index];
              productPackage.packageItems = result.data;
              temp[index] = productPackage;
              setPackages(temp);

              setLoading(false);
          },
              (error) => {
                  setGridData([]);
                  setLoading(false);
                  console.log(error);
                  showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
              }
          )
          .catch((error) => {
              console.log(error);
              showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
          });
  }

    useConstructor(() => Initialise())
    function Initialise() {
      renewToken();
      
      hasChanges.current = false;
      setSelectedPackageId(-1);
      setSearchText("");
      SearchPackage("");
    }

    return (
        <div className={style.PageMain}>
            <Title pageTitle="Product Package Management" />
            <div className={style.PageContent}>
              <div className={style.ModalContent}>
                <div className={style.PageFieldsFullHeight}>
                  <div className={style.ModalContentFieldOneQuarterWidth}>
                  <StyledBox>
                    <DataGridPro
                      getRowId={(row) => row.id}
                      rows={packages}
                      columns={packagecolumns}
                      loading={loading}
                      components={{
                        Toolbar: PackageToolbar
                      }}
                      rowHeight={tinyScreen ? 20 : (smallScreen ? 24 : 28)}
                      onRowClick={(params) => {
                        setSelectedPackageId(params.row.packageID);
                        ReloadPackageItems(params.row.packageID);
                      }}
                    />
                    </StyledBox>
                  </div>
                  <div className={style.ModalContentFieldThreeQuarterWidth}>
                    <DataGridPro
                      getRowId={(row) => row.id}
                      rows={gridData}
                      columns={columns}
                      pageSize={100}
                      pagination
                      loading={loading}
                      components={{
                        Toolbar: PackageItemToolbar
                      }}
                      rowHeight={tinyScreen ? 20 : (smallScreen ? 24 : 28)}
                      onRowClick={(params) => setSelectedProductId(params.row.productID)}
                    />
                  </div>
                </div>
              </div>
            </div>

          <SnackBarMessage {...snackSettings} />

          <ProductList
            ref={productListModalRef}
            onClose={(hasSelection: boolean, productItems: React.MutableRefObject<ProductListItem[]>) => PopulateSelectedProducts(hasSelection, productItems)}
          />

        </div>
    );


  }

